export
const name: string = "ShadowMapDepth";

export
const preproc: string = ``;

export
const declaration: string = ``;

export
const varyings: string = `
    varying vec4 v_position;
    varying float v_visibility;
`;

export
const implementation: string = `
    void main()
    {
        if (v_visibility < 0.5) {
    		discard;
    	}

    #ifdef CLIPPING_PLANE
        resolveClippingPlane();
    #endif

        float depth = 0.5 + (v_position.z / v_position.w) * 0.5;
        gl_FragColor = vec4(vec3(depth), 1.0);
        //gl_FragColor = floatToVec4(depth);

    #ifdef LOGDEPTH
        resolveLogarithmicDepth();
    #endif
    }
`;
